const BP = {
    MOBILE: '576px',
};

export default BP;
